export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },

    {
      name: 'Antecedentes',
      url: '/antecedents',
      icon: 'icon-event'
    },

    {
      name: 'Sintomas',
      url: '/symptoms',
      icon: 'icon-target'
    },

    {
      name: 'Diagnósticos',
      url: '/diagnostics',
      icon: 'icon-list'
    },

    {
      name: 'Categorias',
      url: '/category',
      icon: 'icon-tag'
    },

    {
      name: 'Especialidades',
      url: '/speciality',
      icon: 'icon-badge'
    },

    {
      name: 'Clientes',
      url: '/clients',
      icon: 'icon-user'
    },
    
    {
      name: 'Médicos',
      url: '/doctors',
      icon: 'icon-briefcase'
    },
    {
      name: 'Grupos',
      url: '/groups',
      icon: 'icon-people'
    },

    {
      name: 'Logout',
      url: '/logout',
      icon: 'icon-lock'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_navAdmin.js